/**
 * Central permission configuration.
 * Each entry has:
 *   key        — the string stored in Firestore admins.permissions[]
 *   label      — human-readable name shown in the UI
 *   group      — section group for checkbox grouping in the form
 */

export const PERMISSIONS = [
  // ─── Core ─────────────────────────────────────────
  { key: 'dashboard',    label: 'Dashboard',     group: 'Core' },
  { key: 'admin_users',  label: 'Admin Users',   group: 'Core' },

  // ─── Islamic Content ──────────────────────────────
  { key: 'quran',        label: 'Quran',         group: 'Islamic Content' },
  { key: 'hadith',       label: 'Hadith',        group: 'Islamic Content' },
  { key: 'duas',         label: 'Duas',          group: 'Islamic Content' },
  { key: 'tasbeeh',      label: 'Tasbeeh',       group: 'Islamic Content' },
  { key: 'prophets',     label: 'Prophets',      group: 'Islamic Content' },

  // ─── Media & Publishing ───────────────────────────
  { key: 'banners',      label: 'Banners',       group: 'Media & Publishing' },
  { key: 'quotes',       label: 'Quotes',        group: 'Media & Publishing' },
  { key: 'categories',   label: 'Categories',    group: 'Media & Publishing' },

  // ─── Communication ────────────────────────────────
  { key: 'notifications', label: 'Notifications', group: 'Communication' },
  { key: 'messages',     label: 'Messages',      group: 'Communication' },
  { key: 'tickets',      label: 'Tickets',       group: 'Communication' },
  { key: 'feedback',     label: 'Feedback',      group: 'Communication' },

  // ─── User & System ────────────────────────────────
  { key: 'users',        label: 'App Users',     group: 'User & System' },
  { key: 'maintenance',  label: 'Maintenance',   group: 'User & System' },
];

/** Convenience: map key → label */
export const PERMISSION_LABELS = Object.fromEntries(
  PERMISSIONS.map((p) => [p.key, p.label])
);

/** All available roles */
export const ROLES = [
  { value: 'admin',        label: 'Admin' },
  { value: 'editor',       label: 'Editor' },
  { value: 'viewer',       label: 'Viewer' },
];

/** Keys that are always visible regardless of permission (dashboard) */
export const ALWAYS_VISIBLE = ['dashboard'];
